module.exports = __webpack_public_path__ + "static/media/five-days-active.94712e50.png";